import { Col, Row } from 'antd';
import { GroupSlicerResultPage } from 'Utils/UtilityFunctions';
import BuyerGroupSkeleton from './BuyerGroupSkeleton';

type Props = {
  sliceFlag?: boolean;
  inGlobalSearch?: boolean,
};

const defaultProps: Props = {
  sliceFlag: false,
  inGlobalSearch: false,
};

const SearchBuyerGroupSkeletonBlock = function SearchBuyerGroupSkeletonBlock(props: Props) {
  const { sliceFlag, inGlobalSearch } = props;
  const slicerGroupNumber = GroupSlicerResultPage();

  const skeletonArray = Array.from({ length: 12 }, (_, index) => index + 1);
  const arrayLength = !sliceFlag ? 12 : slicerGroupNumber;

  return (
    <Row
      gutter={[{
        xs: 16, lg: 40, md: 32, sm: 32,
      }, 16]}
      className="Grid-width-row gridUpdated"
    >
      {skeletonArray.slice(0, arrayLength).map((item) => (
        <Col span={6} xs={12} md={4} lg={4} sm={4} className="gutter-row" key={item}>
          <BuyerGroupSkeleton
            border
            inGlobalSearch={inGlobalSearch}
          />
        </Col>
      ))}
    </Row>
  );
};

SearchBuyerGroupSkeletonBlock.defaultProps = defaultProps;
export default SearchBuyerGroupSkeletonBlock;
